import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'tp-delete-item',
  templateUrl: './delete-item.component.html',
  styleUrls: ['./delete-item.component.scss']
})
export class DeleteItemComponent implements OnInit {
  @Input() itemName: string;

  @Output() deleteItem = new EventEmitter<boolean>();
  constructor() {}

  ngOnInit(): void {}
}
